import actions from '@devices/settings/device_settings/actions.js';
import sensor_actions from '@devices/settings/device_settings/sensor_actions.js';
import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyflood',
	friendly_name: 'Flood',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'floodAlarm', 'lowBattery'],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{ title: 'temperature_unit', component: 'temperature_unit' },
						{
							title: 'temperature_threshold',
							component: 'temperature_threshold',
						},
						{ title: 'temperature_offset', component: 'temperature_offset' },
						{ title: 'rain_mode', component: 'rain_mode' },
					],
				},
				actions,
				sensor_actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_reconnect', component: 'wifi_reconnect' },
						{ title: 'restrict_login', component: 'restrict_login' },
					],
				},
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: ['temp_over_url', 'temp_under_url'],
			hideFromSensorActions: ['report_url', 'flood_gone_url', 'flood_detected_url'],
		},
	},
};
